export default __webpack_public_path__ + "static/devops-career-banner-6765cb7a39f65df94e8caf5304256ec6.jpg";